import { useEffect } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  CircularProgress,
  Box,
  Typography,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import PrintIcon from '@mui/icons-material/Print'
import DownloadIcon from '@mui/icons-material/Download'
import usePdfPrintTemplate from 'src/mentor/components/MentorPrescriptionTemplates/components/hooks/usePdfPrintTemplate'

export default function PdfPreviewDialog({ prescriptionTemplateData, clinicId, useEmptyBox = false, onClose, open, apiFn, apiEndpoint, extraParams }) {
  const {
    pdfTemplateBlobUrl,
    getPrescriptionTemplatePdf,
    downloadPdf,
    fetchingPdf,
    downloadingPdf,
    error,
  } = usePdfPrintTemplate({
    prescriptionTemplateId: prescriptionTemplateData?.id,
    clinicId,
    useEmptyBox,
    apiFn,
    apiEndpoint,
    extraParams,
  })

  // Fetch PDF when dialog opens or useEmptyBox changes
  useEffect(() => {
    if (open) {
      getPrescriptionTemplatePdf()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, useEmptyBox])

  // Handle print functionality
  const handlePrint = () => {
    if (pdfTemplateBlobUrl) {
      // Open PDF in new window and trigger print
      const printWindow = window.open(pdfTemplateBlobUrl, '_blank')
      if (printWindow) {
        printWindow.onload = () => {
          printWindow.print()
        }
      }
    }
  }

  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      <DialogTitle>
        PDF Preview
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {fetchingPdf ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="500px"
            flexDirection="column"
          >
            <CircularProgress />
            <Typography variant="body2" sx={{ mt: 2 }}>
              Generating PDF preview...
            </Typography>
          </Box>
        ) : error ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="500px"
            flexDirection="column"
          >
            <Typography color="error" variant="body1">
              {error}
            </Typography>
            <Button onClick={getPrescriptionTemplatePdf} sx={{ mt: 2 }} variant="outlined">
              Retry
            </Button>
          </Box>
        ) : pdfTemplateBlobUrl ? (
          <Box
            sx={{
              width: '100%',
              height: '100%',
            }}
          >
            <iframe
              src={pdfTemplateBlobUrl}
              title="PDF Preview"
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
              }}
            />
          </Box>
        ) : (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="500px"
            flexDirection="column"
          >
            <Typography variant="body1">No PDF available</Typography>
            <Button onClick={getPrescriptionTemplatePdf} sx={{ mt: 2 }} variant="outlined">
              Generate Preview
            </Button>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button
          onClick={downloadPdf}
          disabled={downloadingPdf}
          startIcon={downloadingPdf ? <CircularProgress size={20} /> : <DownloadIcon />}
          variant="outlined"
        >
          {downloadingPdf ? 'Downloading...' : 'Download'}
        </Button>
        {/* <Button
          onClick={handlePrint}
          disabled={!pdfTemplateBlobUrl || fetchingPdf}
          startIcon={<PrintIcon />}
          variant="contained"
        >
          Print
        </Button> */}
      </DialogActions>
    </Dialog>
  )
}
